<template>
  <v-row>
    <v-col cols="12" sm="12" md="12">
      <v-text-field
        required
        :label="`${$t('poll.lblSurveyQuestion')} *`"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <!-- {{ options }} -->
      <option-form v-model="options"></option-form>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <v-switch hide-details :label="$t('poll.lblMandatoryResponse')" class="mt-0 pt-0"></v-switch>
    </v-col>
  </v-row>
</template>

<script>
import OptionForm from "./OptionForm.vue";
export default {
  name: "QuestionForm",
  components: { OptionForm },
  data() {
    return {
      options: ["", ""],
    };
  },
};
</script>

<style>
</style>